var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecorded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 70,
    height: 70,
    rx: 10,
    fill: "#E6FFF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_2148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.667 20C27.3827 20 20.667 26.7157 20.667 35C20.667 43.2842 27.3827 49.9999 35.667 49.9999C43.9512 49.9999 50.6669 43.2842 50.6669 35C50.6581 26.7194 43.9476 20.0089 35.667 20ZM41.984 35.4779C41.8802 35.6862 41.7114 35.8551 41.503 35.9589V35.9643L32.9316 40.25C32.4023 40.5145 31.7588 40.2998 31.4942 39.7705C31.419 39.62 31.3803 39.4539 31.3812 39.2857V30.7143C31.381 30.1225 31.8604 29.6427 32.4522 29.6423C32.6186 29.6423 32.7828 29.681 32.9316 29.7554L41.503 34.0411C42.0326 34.305 42.248 34.9483 41.984 35.4779Z",
    fill: "#00C968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_2148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(20.667 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorded);
export default __webpack_public_path__ + "static/media/recorded.590b103d9af92b6da5cb9e376c111b62.svg";
export { ForwardRef as ReactComponent };